import { render, staticRenderFns } from "./CMRemindSettingContactList.vue?vue&type=template&id=2165eef5&"
import script from "./CMRemindSettingContactList.vue?vue&type=script&lang=js&"
export * from "./CMRemindSettingContactList.vue?vue&type=script&lang=js&"
import style0 from "./CMRemindSettingContactList.vue?vue&type=style&index=0&id=2165eef5&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2165eef5')) {
      api.createRecord('2165eef5', component.options)
    } else {
      api.reload('2165eef5', component.options)
    }
    module.hot.accept("./CMRemindSettingContactList.vue?vue&type=template&id=2165eef5&", function () {
      api.rerender('2165eef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMRemindSettingContactList.vue"
export default component.exports